export function verifyPhone(rule, value, callback) {
  if (/^1[0-9]{10,10}$/.test(value)) {
    callback();
  } else {
    callback(new Error('请填写正确的手机号'));
  }
}
export function verifyId(rule, value, callback) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error('请填写正确的身份证号码'));
  }
}
export function verifyId_HUZHAO(rule, value, callback) {
  var reg = /^[a-zA-Z0-9]{5,17}$/;

  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error('请填写正确的护照号码'));
  }
}
export function verifyId_GANGAO(rule, value, callback) {
  var reg = /^[HMhm]([0-9]{10}|[0-9]{8})$/;

  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error('请填写正确的港澳通行证'));
  }
}
export function verifyId_TAIBAO(rule, value, callback) {
  var d = /^[0-9]{10}$/;
  var b = /^[0-9]{8}$/;

  if (d.test(value) || b.test(value)) {
    callback();
  } else {
    callback(new Error('请填写正确的台湾通行证'));
  }
}